import type {ElementId, GData, Group, SelectOption} from './types';
import GroupData from "./GroupData";
import ColorizerStorage from './ColorizerStorage';
import Config from './config';
import {ColorPicker } from '../ColorPicker2/ColorPicker';
import type { ColorPickerInstance} from '../ColorPicker2/ColorPicker';
import {featureGroupName} from "./featureGroupName";

// @ts-ignore
import {_} from '../../Lang.class.js';
import {SearchInput} from "../SearchInput/SearchInput";

interface ModalColorizerSetupGroupCallbacks {
    onSaveGroups(groupData: GData): void;
}

interface ModalColorizerSetupGroup {
    mainRoot: HTMLDivElement,
    originalFilter: any;
    callbacks: ModalColorizerSetupGroupCallbacks;
    element: HTMLElement;
    useFilter: boolean | null;
    groupData: GroupData;
    selectedGroupId: number | null;
    availableOptions: SelectOption[];
    selectedType: string;
    maxCreateGroups: number;
    niceColorsTable: string[];
    colorPicker: ColorPickerInstance;
    init(): void;
    getElement(): HTMLDivElement;
    setUseFilter(useFilter: boolean): void;
    reloadPreparedGroups(): void;
}

class ModalColorizerSetupGroup implements ModalColorizerSetupGroup {

    constructor(mainRoot: HTMLDivElement, originalFilter: any, callbacks: ModalColorizerSetupGroupCallbacks) {
        this.mainRoot = mainRoot;
        this.maxCreateGroups = 7;
        this.originalFilter = originalFilter;
        this.availableOptions = [];

        this.callbacks = callbacks;
        this.useFilter = null;

        this.niceColorsTable = Config.analyticsColorsShort;

        this.selectedGroupId = null;

        this.groupData = new GroupData();

        this.colorPicker = ColorPicker({
            onColorChange: (block_id: number, color: string) => {
                console.log('ColorizeSlider, onColorChange, block_id', block_id, 'color', color);
                this.groupData.setGroupColor(block_id, color);
                this.reloadPreparedGroups();
                (this.element.querySelector('.js-color') as HTMLDivElement).style.backgroundColor = color;
            },
            onColorPickerClose: () => {
                console.log('ColorizeSlider, onColorPickerClose');
            }
        });

        this.init();
    }

    setData(gData: GData, withReload: boolean = true) {
        console.log('ModalColorizerSetupGroup, setData', gData);
        this.groupData = (new GroupData()).load(gData);
        this.setSelectedType(this.groupData.getTypeName() || this.selectedType);
        this.selectedGroupId = null;
        if (withReload) {
            this.reloadPreparedGroups();
            this.reloadGroupEdit();
        }
    }

    setDefaultData() {
        console.log('ModalColorizerSetupGroup, setDefaultData');
        this.groupData = new GroupData();
        this.groupData.addGroup({
            id: 1,
            name: 'Nowa grupa',
            color: this.niceColorsTable[0],
            is_removable: true,
            is_name_auto_created: true,
            element_ids: []
        })
        this.selectedGroupId = 1;
        this.reloadPreparedGroups();
        this.reloadGroupEdit();
    }

    setUseFilter(useFilter: boolean) {
        this.useFilter = useFilter;
    }

    setSelectedType(type: string) {
        console.log('ModalColorizerSetupGroup, setSelectedType', type, 'this.selectedType', this.selectedType, 'this.groupData.getTypeName()', this.groupData.getTypeName(), 'this.groupData', this.groupData);
        this.selectedType = type;
        this.availableOptions = this.originalFilter.getAvailableValues(this.selectedType);
        this.groupData.setTypeName(this.selectedType);
        console.log('ModalColorizerSetupGroup, this.availableOptions', this.availableOptions);
    }

    init() {
        this.element = document.createElement('div');
        this.element.innerHTML = this.getHTML();

        // this.element.querySelector('.js-color-picker-group')?.appendChild(this.colorPicker.div);
        let color_picker_parent = this.mainRoot.querySelector('.geocoding-app') as HTMLDivElement;
        if (color_picker_parent) {
            console.log('ModalColorizerSetupGroup, init, color_picker_parent', color_picker_parent);
            let color_picker_element = color_picker_parent.querySelector('.js-color-picker-group') as HTMLDivElement;
            if (!color_picker_element) {
                console.log('ModalColorizerSetupGroup, init, not exists, color_picker_element', color_picker_element);
                color_picker_element = document.createElement('div');
                color_picker_element.className = 'js-color-picker-group';
                color_picker_element.style.zIndex = '30000';
                color_picker_element.style.top = '0px';
                color_picker_element.style.left = '0px';
                color_picker_element.style.position = 'absolute';
                color_picker_parent.appendChild(color_picker_element);
            }
            if (color_picker_element) {
                console.log('ModalColorizerSetupGroup, init, exists,  color_picker_element', color_picker_element, this.colorPicker.div);
                color_picker_element.innerHTML = '';
                color_picker_element.appendChild(this.colorPicker.div);
            } else {
                throw new Error('ColorizeSlider, reload, color_picker_element not found');
            }
        } else {
            throw new Error('ColorizeSlider, reload, color_picker_parent not found');
        }

        this.reloadPreparedGroups();
        this.reloadGroupEdit();

        // Add new empty group
        let addGroupButton = this.element.querySelector('.js-add-group');
        if (addGroupButton) {
            addGroupButton.addEventListener('click', (e) => {
                let newGroupName = featureGroupName.getUniqueName('Nowa grupa', this.groupData.getGroupsNames());
                let group_id = this.groupData.addGroup({
                    id: 0,
                    name: newGroupName,
                    color: '#a50026',
                    is_removable: true,
                    is_name_auto_created: true,
                    element_ids: []
                });
                this.groupData.setGroupColor(group_id, this.niceColorsTable[group_id % this.niceColorsTable.length]);
                this.selectedGroupId = group_id;
                console.log('addGroupButton click', group_id, this.selectedGroupId);
                this.reloadPreparedGroups();
                this.reloadGroupEdit();
            });
        }

        let saveButton = this.element.querySelector('.js-save');
        if (saveButton) {
            saveButton.addEventListener('click', (e) => {
                this.callbacks.onSaveGroups(this.groupData.getData());
            });
        }

    }
    
    validateAll(): boolean {
        
        const disableSaveButton = () => {
            let jsButtonApply = this.element.querySelector('.js-save');
            if (jsButtonApply) {
                jsButtonApply.classList.add('button-disabled');
                jsButtonApply.setAttribute('disabled', 'disabled');
            }
        }
        
        const enableSaveButton = () => {
            let jsButtonApply = this.element.querySelector('.js-save');
            if (jsButtonApply) {
                jsButtonApply.classList.remove('button-disabled');
                jsButtonApply.removeAttribute('disabled');
            }
        }
        
        console.debug('ModalColorizerSetupGroup, validateAll');
        let jsError = this.element.querySelector('.js-error');
        let jsButtonApply = this.element.querySelector('.js-save');
        if (jsError && jsButtonApply) {

            jsError.innerHTML = '';
            enableSaveButton();
            
            if (this.groupData.getGroups().length < 1) {
                jsError.innerHTML = 'Musisz dodać przynajmniej jedną grupę';
                disableSaveButton();
                return false;
            }
            
            // Check if all groups have name
            let groups = this.groupData.getGroups();
            for (let i = 0; i < groups.length; i++) {
                if (!groups[i].name) {
                    jsError.innerHTML = 'Wszystkie grupy muszą mieć nazwę';
                    disableSaveButton();
                    return false;
                }
            }
            
            // Check if all groups have unique name
            let groupsNames = this.groupData.getGroupsNames();
            let uniqueNames = groupsNames.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            if (groupsNames.length !== uniqueNames.length) {
                jsError.innerHTML = 'Wszystkie grupy muszą mieć unikalną nazwę';
                disableSaveButton();
                return false;
            }
            
            // Check if all groups have at least one element
            for (let i = 0; i < groups.length; i++) {
                if (groups[i].element_ids.length < 1) {
                    jsError.innerHTML = 'Każda grupa musi mieć wybrany przynajmniej jeden element';
                    disableSaveButton();
                    return false;
                }
            }
            
            return true;
        }
        console.warn('validateAll, not found jsError or jsButtonApply');
        return false;
    }

    reloadPreparedGroups() {
        let colorBinderHolder = this.element.querySelector('#colorBinderHolder');
        if (!colorBinderHolder) {
            throw new Error('colorBinderHolder not found');
        }
        colorBinderHolder.innerHTML = '';
        if (!this.groupData) {
            console.warn('this.groupData is not set');
            return;
        }

        let addGroupButton = this.element.querySelector('.js-add-group');
        if (addGroupButton) {
            if (this.groupData && this.groupData.getGroups().length >= this.maxCreateGroups) {
                addGroupButton.classList.add('disabled');
                addGroupButton.setAttribute('disabled', 'disabled');
            } else {
                addGroupButton.classList.remove('disabled');
                addGroupButton.removeAttribute('disabled');
            }
            this.validateAll();
        }

        console.log('reloadPreparedGroups', this.groupData);
        for (let group of this.groupData.getGroups()) {
            let element = this.createGroupElement(group);
            colorBinderHolder.appendChild(element);
        }

        // Add rest group
        colorBinderHolder.appendChild(this.createGroupElement({
            id: -1, name: _('RestItems'),
            color: ColorizerStorage.defaultColorForUnassigned, // FIXME: get this value from colorizer settings (TheView.colorize)
            is_removable: false,
            is_name_auto_created: false,
            element_ids: []
        }));

    }

    createGroupElement(group: Group): HTMLDivElement {
        // console.log('reloadPreparedGroups', group);
        let element = document.createElement('div');
        let is_removable = group.is_removable;
        element.innerHTML = `
            <div class="groupOptionHolder groupOption ${(group.id === this.selectedGroupId ? ' active ' : '')}">
                <div class="leftGroupContainer">
                    <div class="groupColor" style="background-color:${group.color}"></div>
                    <div class="groupOptionPicker" style="border-color: ${group.color}">${group.name}</div>
                    <div ` + (!is_removable && ` style="display: none;" `) + ` class="removeButton" title="Usuń grupę"><i class="mdi mdi-close"></i></div>
                </div>
                <div class="groupDescription" title=""></div>
            </div>
            `;

        if (is_removable) {
            // Remove group
            let removeButton = element.querySelector('.removeButton');
            if (removeButton) {
                removeButton.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.groupData.removeGroup(group.id);
                    // If user removed selected group, then reload
                    if (group.id === this.selectedGroupId) {
                        this.selectedGroupId = null;
                        this.reloadGroupEdit();
                    }
                    this.reloadPreparedGroups();
                    this.validateAll();
                });
            }

            // Select group
            let groupOption = element.querySelector('.groupOption');
            if (groupOption) {
                groupOption.addEventListener('click', (e) => {
                    this.selectedGroupId = group.id;
                    this.reloadPreparedGroups();
                    this.reloadGroupEdit();
                });
            }

            // groupDescription
            let maxVisibleElements = 3;
            let groupDescription = element.querySelector('.groupDescription');
            if (groupDescription) {
                let ids = this.groupData.getSelectedElements(group.id);
                let elementsNames: string[] = [];
                for (let id of ids.slice(0, maxVisibleElements)) {
                    let name = this.availableOptions.find((option) => option.id === id)?.name;
                    if (name) {
                        elementsNames.push(name);
                    }
                }
                groupDescription.innerHTML = elementsNames.join(', ');
                if (ids.length > maxVisibleElements) {
                    groupDescription.innerHTML += ` (+${ids.length - maxVisibleElements})`;
                }
            }
        }

        return element;
    }
    
    updateCurrentGroupName(name: string) {
        (this.element.querySelector('.js-name') as HTMLInputElement).value = name;
    }

    reloadGroupEdit() {
        let groupEdit = this.element.querySelector('.js-group-edit');
        if (!groupEdit) {
            throw new Error('groupEdit not found');
        }
        if (this.selectedGroupId === null) {
            groupEdit.innerHTML = `
                <div class="groupEditWelcome" style="font-size: 0.95rem; margin: 0 auto;">
                    Wybierz grupę lub utwórz nową
                </div>
            `;
            return;
        }

        let group = this.groupData.getGroup(this.selectedGroupId);
        /*
            <div class="groupColorPicker" style="
            background-color: ${group?.color};
            width: 27px;
            height: 27px;
            border: 0;
            border-radius: 3px;
            cursor: pointer;
            margin-right: 5px;"></div>
            */

        groupEdit.innerHTML = `
        <div style="
            font-size: 16px;
            font-weight: lighter;
            margin-bottom: 10px;
            ">Edycja grupy</div>
        <div class="groupTitle" style="display: flex; align-items: center; justify-content: start;">
            <div class="js-color" style="
            padding: 0;
            margin: 0;
            border: 0;
            border-radius: 3px;
            width: 29px;
            height: 29px;
            background-color: ${group?.color};
            cursor: pointer;
            flex: 0 0 auto;
            "></div>
            <input type="text" class="js-name" style="
                border-radius: 3px;
                border: 1px solid gray;
                margin-left: 6px;
                padding: 3px 6px;
                width: 100%;
                " title="Nazwa grupy" maxlength="50">
        </div>
        
        <div class="js-search-input"></div>
        
        <div class="js-elements-available checkBoxGroupHolder mini-scrollbar">
        </div>`;
        
        new SearchInput( groupEdit.querySelector('.js-search-input') as HTMLDivElement, {
            onChange: (searchString: string) => {
                // add class 'hidden-option' where option name not contains searchString
                let labels = groupEdit.querySelectorAll('.js-elements-available label') as NodeListOf<HTMLLabelElement>;
                labels.forEach(label => {
                    if (searchString !== '' && label.querySelector('.checkbox_label').innerHTML.toLowerCase().indexOf(searchString.toLowerCase()) === -1) {
                        label.classList.add('hidden');
                    } else {
                        label.classList.remove('hidden');
                    }
                });
            }
        });

        // Name edit
        let nameInput = groupEdit.querySelector('.js-name') as HTMLInputElement;
        if (nameInput) {
            nameInput.value = group?.name && group.name.length > 0 ? group.name : '';
            nameInput.addEventListener('input', (e) => {
                let input = e.target as HTMLInputElement;
                if (input && this.selectedGroupId !== null) {
                    this.groupData.setGroupName(this.selectedGroupId, input.value);
                    if (input.value === '') {
                        this.groupData.setGroupNameAutoCreated(this.selectedGroupId, true);
                    }
                    this.reloadPreparedGroups();
                    this.validateAll();
                } else {
                    throw new Error('input or selectedGroupId not found');
                }
            });
        }

        let colorInput = groupEdit.querySelector('.js-color') as HTMLInputElement;
        if (colorInput) {
            colorInput.addEventListener('click', (e) => {
                if (this.selectedGroupId !== null) {
                    console.log('click, ', this.groupData.getGroup(this.selectedGroupId));
                    this.colorPicker.setColor(this.groupData.getGroup(this.selectedGroupId)?.color || '#000000');
                    this.colorPicker.setPosition(e.clientX - 140, e.clientY + 30);
                    this.colorPicker.show(this.selectedGroupId);
                } else {
                    console.warn('selectedGroupId not found');
                }
            });
        }

        // Listing elements as checkboxes
        let elementsAvailable = groupEdit.querySelector('.js-elements-available');
        let selectedElementsIds: ElementId[] = [];
        if (group) {
            selectedElementsIds = this.groupData.getSelectedElements(group.id);
        }
        
        let elementsInAnotherGroups = this.groupData.getSelectedElementsInAnotherGroups(this.selectedGroupId);
        
        this.availableOptions.map((element: SelectOption) => {
            
            // If elements is selected in another group, skip it
            if (elementsInAnotherGroups.includes(element.id)) {
                return;
            }
            let option = this.createAvailableOption(element, selectedElementsIds);
            elementsAvailable?.appendChild(option);
        });
    }
    
    private createAvailableOption(element: SelectOption, selectedElementsIds: ElementId[]) {
        let option = document.createElement('label');
        // option.setAttribute('data-id', String(element.id));
        option.classList.add('super-checkbox', 'super-checkbox-black');
        option.innerHTML = `
                    <input type="checkbox" name="" value="${element.id}" ${(selectedElementsIds.includes(element.id) ? ` checked="true" ` : "")}>
                    <span class="checkbox_label">${element.name}</span>
                        `;
        if (option) {
            option.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                let checkbox = option.querySelector('input');
                if (checkbox) {
                    if (this.selectedGroupId !== null) {
                        if (checkbox.checked) {
                            this.groupData.removeElementFromGroup(this.selectedGroupId, element.id);
                        } else {
                            this.groupData.addElementToGroup(this.selectedGroupId, element.id);
                        }
                        this.autoCreateGroupName();
                        this.reloadPreparedGroups();
                    } else {
                        throw new Error('Cannot add/remove element to/from group, because selectedGroupId is null');
                    }
                    checkbox.checked = !checkbox.checked;
                    this.validateAll();
                }
            });
        } else {
            throw new Error('Cannot find label element');
        }
        return option;
    }
    
    private autoCreateGroupName() {
        if (this.groupData.isNameAutoCreated(this.selectedGroupId)) {
            let selectedElementNames: string[] = this.groupData.getSelectedElements(this.selectedGroupId).map((elementId) => {
                return this.availableOptions.find((option) => option.id === elementId)?.name;
            });
            this.groupData.makeAutoGroupName('fromElementNames', this.selectedGroupId, selectedElementNames, 'Nowa groupa');
            this.updateCurrentGroupName(this.groupData.getGroup(this.selectedGroupId)?.name || '');
        }
    }
    
    getElement() {
        return this.element;
    }

    getHTML() {
        return `
                        <div class="telematics-colorize_body">
                            <div style="max-width: 520px; display: flex; flex-direction: row; height: 320px;">
                                <div class="group-left-panel">
                                    <div class="colorize_header_selected" style="padding: 20px 20px 5px 20px;">
                                        <div style="font-size: 16px; font-weight: lighter;">
                                            Wybrane
                                        </div>
                                        <div style="font-size: 11px; opacity: 0.5;">Maksimum ${this.maxCreateGroups} pozycji</div>
                                    </div>
                                    <div id="colorBinderHolder" class="mini-scrollbar">
                                    </div>
                                    <div class="button_add_group_container" style="padding: 0 25px 25px 25px;">
                                        <button class="button button_black js-add-group">Utwórz grupę</button>
                                    </div>
                                </div>
                                <div class="group-right-panel js-group-edit">
                                </div>
                            </div>
                            <div class="js-color-picker-group"></div>
                        </div>
                        <div class="telematics-colorize_footer" style="background-color: #dbdbd6; display: flex; justify-content: end;">
                            <div style="width: 100%; max-width: 327px;">
                                <div class="js-error"></div>
                            </div>
                            <div>
                                <div style="width: 140px;">
                                    <button class="js-save button button_black button-primary">Zastosuj</button>
                                </div>
                            </div>
                        </div>
        `;
    }

}

export default ModalColorizerSetupGroup;